/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useMemo, useState } from "react";

import { sum } from "utils/operator";
import { formatCurrency } from "utils/mask";
import { EnumStages } from "views/Billet/types";
import { EnumFormaPagamento, EnumPaymentForm } from "services/types";
import { IStagesBilletPaymentForm } from "models";
import usePayment from "hooks/usePayment";
import { useWhitelabel } from "hooks/useWhitelabel";
import { Button } from "components";

import InfoFrameImage from "assets/images/icons/blue-circle-info.svg";
import Order3 from "assets/images/icons/order-3.svg";
import * as S from "./styles";
import OptionsPayments from "./components/OptionsPayments";
import FormPayment from "./components/FormPayment";
import { eventBus } from "utils/eventBus";
import { useFlowResume } from "./hooks/FlowResume";

export const PaymentForm: React.FC<IStagesBilletPaymentForm> = ({ setStage, paymentForm, setPaymentForm, enable }) => {
  const { dataPaymentBillet, setDisableEditValueInput, isEnableCheckout, paymentCard, paymentMethods } = usePayment();
  const { getInstallments, isLoading } = useFlowResume({ goToResume: () => setStage(EnumStages.SUMMARY) });

  const [sumBillets, setSumBillets] = useState(0);
  const [enableFlowPix, setEnableFlowPix] = useState(true);
  const [methodSelected, setMethodSelected] = useState<EnumFormaPagamento | null>(null);

  const { client } = useWhitelabel();

  const { is_credit_disabled, is_pix_disabled, is_debit_disabled } = useMemo(() => {
    if (!client) {
      return {
        is_credit_disabled: false,
        is_pix_disabled: false,
        is_debit_disabled: false,
      };
    }
    return {
      is_credit_disabled: !client?.credit_card_enable,
      is_pix_disabled: !client?.pix_enable,
      is_debit_disabled: !client.debit_card_enable,
    };
  }, [client]);

  useEffect(() => {
    if (!client) {
      return;
    }

    if (client?.pix_enable && enableFlowPix) {
      setPaymentForm(EnumPaymentForm.PIX);
    }
    if (client?.credit_card_enable && enableFlowPix) {
      setPaymentForm(EnumPaymentForm.CREDIT);
    }
  }, [client, paymentForm]);

  useEffect(() => {
    const amountBillets = dataPaymentBillet?.billets?.map(
      (billet) => billet.amount.total
    );
    const amountDebits = dataPaymentBillet?.debits
      ?.filter((debit) => !debit?.redirect_to_be_paid)
      .map((debit) => debit.amount);
    const amountPix = dataPaymentBillet?.pix?.map((pix) => pix.amount.total);

    setSumBillets(sum([...amountBillets, ...amountDebits, ...amountPix]));
  }, [dataPaymentBillet, paymentCard]);

  useEffect(() => {
    setDisableEditValueInput(false);
  }, []);

  function handleGoResume() {
    eventBus.emit("formPaymentClicked");
    //setStage(EnumStages.SUMMARY);
  }

  useEffect(() => {
    if (paymentMethods.length) {
      getInstallments();
    }
  }, [paymentMethods]);

  return (
    <S.PaymentWrapper enable={enable}>
      <S.WrapperBox>
        <S.TitleRow>
          <S.OrderImg src={Order3} />
          <S.Title>Pagamento</S.Title>
        </S.TitleRow>

        <S.Row>
          <S.WrapperValue value={false}>
            <S.LabelValue>Total a pagar dos débitos</S.LabelValue>
            <S.Value value={false}>{formatCurrency(sumBillets)}</S.Value>
          </S.WrapperValue>
        </S.Row>

        {[is_credit_disabled, is_pix_disabled, is_debit_disabled].some((value) => Boolean(!value)) && (
          <>
            <S.InfoHeader>Pagar com</S.InfoHeader>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "10px",
              }}
            >
              {methodSelected && (
                <Button
                  title="Alterar método de pagamento"
                  type_button="secondary"
                  height={30}
                  font_size={14}
                  paddingHorizontal={10}
                  style={{ width: "fit-content", marginBottom: "10px" }}
                  onClick={() => setMethodSelected(null)}
                />
              )}
            </div>
            {enable && !methodSelected && (
              <OptionsPayments setPaymentMethod={setMethodSelected} />
            )}

            <FormPayment method={methodSelected} />
          </>
        )}

        {is_credit_disabled && is_pix_disabled && (
          <S.PixInformationContainer enable>
            <S.InfoHeaderRow>
              <S.InfoImg src={InfoFrameImage} />

              <S.InfoHeader>Informação</S.InfoHeader>
            </S.InfoHeaderRow>
            <S.InfoTextRow>
              <S.InfoText>
                O estabelecimento não está habilitado para receber pagamentos.
              </S.InfoText>
            </S.InfoTextRow>
          </S.PixInformationContainer>
        )}

        <S.WrapperButton>
          <S.ButtonPayNow>
            <Button
              title="Ir para pagamento"
              type_button="primary"
              paddingHorizontal={0}
              action={handleGoResume}
              loading={isLoading}
              disabled={(!isEnableCheckout || !methodSelected)}
            />
          </S.ButtonPayNow>
        </S.WrapperButton>
      </S.WrapperBox>
    </S.PaymentWrapper>
  );
};
